module.exports = __webpack_public_path__ + "static/media/veneto-village-02.e4cd802e.jpg";